import PromoPageV1 from "../screens/PromoPageV1"
import PromoPageV2 from "../screens/promo-pages/type2/PromoPageV2"

export const PromoPagesMapping = {
    "promo1" : PromoPageV1,
    "promo2" : PromoPageV2,
    default: PromoPageV1
}